export default __webpack_public_path__ + "178fd50.png";